<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name">Dashboard</div>
        </div>
        <!--page content-->
        <div class="admin-page-content">
            
        </div>
        <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import EventBus from "./event-bus";

    Vue.component("app-footer", Footer);

    export default {
        name: 'Dashboard',
        mixins: [commonMixins],
        data () {
            return {
                mySiteArr: []
            }
        },
        beforeMount() {
            self = this;
        },
        mounted: function() {
            self.setActiveMenu('dashboard');
            EventBus.$emit("menu-selection-changed", "dashboard");
        },
        methods: {
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue